import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import CandidatoCard from './components/CandidatoCard';
import PageHeader from '@spark/ui-components/components/BreadCrumb';

const CandidatoMain = () => {
  return <Container fluid>
      <Row>
        <Col md={12}>
          <PageHeader title="" routeSegments={[{
          name: 'Início'
        }, {
          name: 'Candidatos',
        }]} />
        </Col>
      </Row>
      
      <Row>
        <Col md={12}>
          <CandidatoCard />
        </Col>
      </Row>
    </Container>;
};

export default CandidatoMain;
